import styled from "styled-components";

import { PrintStyleSheet } from "../../seller/advert-seller-details/location/location.styles";

export const Stats = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 1;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 8px;
  background: rgba(36, 45, 61, 0.72);
  color: #fff;
  top: 16px;
  left: 16px;
  ${PrintStyleSheet}
`;

export const StatsIcon = styled.span`
  display: inline-block;
  position: relative;
  width: 24px;
  height: 24px;
  ${PrintStyleSheet}

  svg {
    width: 100%;
    height: 100%;

    path {
      fill: currentColor;
    }
  }

  &:not(:last-child) {
    margin-right: 4px;
  }
`;

export const StatsText = styled.span`
  line-height: 1.7em;
  ${PrintStyleSheet}
`;
